module.exports = __webpack_public_path__ + "img/password_change.b28fe8f2.svg";